import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators, FormRecord } from '@angular/forms';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as fa from '@fortawesome/free-solid-svg-icons';

import { User } from 'src/app/classes/user';
import { UserService } from 'src/app/services/user.service';
import { PasswordComponent } from './password/password.component';
import { HttpClient } from '@angular/common/http';
import { AuthImgPipe } from 'src/app/pipes/auth-img.pipe';
import { Title } from '@angular/platform-browser';

import Languages from 'src/app/constants/languages';
import { Partner } from 'src/app/classes/partner';
import { PartnerService } from 'src/app/services/partner.service';
import { environment } from 'src/environments/environment';
import { AiService } from 'src/app/services/ai.service';
import UserTypes from 'src/app/constants/user-types';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  providers: [AuthImgPipe]
})

export class EditComponent implements OnInit {
  user: User = new User();
  
  form = new FormRecord({
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl(''),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$")
    ]),
    mobile_phone: new FormControl('', [Validators.pattern("^[0-9+ ]+")]),
    type: new FormControl('normal', { nonNullable: true }),
  });

  environment = environment
  activeTab: string = 'basics';
  languages = Languages

  userTypes = UserTypes

  fa = fa

  constructor(
    private userService: UserService,
    private aiService: AiService,
    private partnerService: PartnerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private http: HttpClient,
    private authImgPipe: AuthImgPipe,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {

      if (params['userId'] != 'create') {
        this.userService.get(params['userId']).subscribe(user => {
          this.user = user;

          this.form.patchValue(user);

          this.titleService.setTitle(`${this.user.first_name} ${this.user.last_name}`)
        });
      }

      else {
        this.user = new User;
        this.form.reset();
        this.activeTab = 'basics';
      }
    })

  }

  password() {
    const modalRef = this.modalService.open(PasswordComponent, { centered: true });

    modalRef.componentInstance.user = this.user
  }

  save() {
    this.userService.save(this.user.id, this.form.value).subscribe(data => {
      this.router.navigate(['settings', 'users'])
    });
  }

}
